import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiCall } from "../helper/axios";
import { toast } from "../common_components/Toast/ToastUtils";
// ✅ Async Thunk
export const sendEmailNotification = createAsyncThunk("email/sendEmailNotification", async (payload, { getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const token = auth?.token;
        const response = await ApiCall("POST", "/api/send-email", // 👈 tera backend route
        payload, {
            Authorization: token || ""
        });
        if (response && "data" in response && response.data?.success) {
            return response.data;
        }
        else {
            return rejectWithValue("Failed to send email");
        }
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message ||
            error.message ||
            "Email sending failed");
    }
});
// ✅ Initial State
const initialState = {
    loading: false,
    success: false,
    error: null,
};
// ✅ Slice
const emailSlice = createSlice({
    name: "email",
    initialState,
    reducers: {
        clearEmailState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendEmailNotification.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = false;
        })
            .addCase(sendEmailNotification.fulfilled, (state) => {
            state.loading = false;
            state.success = true;
        })
            .addCase(sendEmailNotification.rejected, (state, action) => {
            state.loading = false;
            state.success = false;
            state.error = action.payload || "Failed to send email";
            toast.error(state.error);
        });
    },
});
// ✅ Actions
export const { clearEmailState } = emailSlice.actions;
// ✅ Selectors
export const selectEmailLoading = (state) => state.email.loading;
export const selectEmailSuccess = (state) => state.email.success;
export const selectEmailError = (state) => state.email.error;
// ✅ Reducer
export default emailSlice.reducer;
